import { render, staticRenderFns } from "./setuserpwd.vue?vue&type=template&id=59d5dcac&"
import script from "./setuserpwd.vue?vue&type=script&lang=ts&"
export * from "./setuserpwd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setuserpwd.vue"
export default component.exports